"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Status = void 0;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./Status.css"));
var _utils = require("../utils");
var _reliability = require("../../../types/reliability");
var _clsx = require("clsx");
var _uiKit = require("@cian/ui-kit");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Status = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.clsx)(styles['status'], styles[(0, _utils.statusToTheme)(props.status)])
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, props.title), props.status === _reliability.EReliabilityStatus.Problem && /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "gray40_100"
  }, "\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043E \u043D\u0430\u0448.\u0434\u043E\u043C.\u0440\u0444")));
};
exports.Status = Status;